import React from 'react';
import { StethoscopeAI } from '../ui/icons/StethoscopeAI';
import { ICON_PX } from '../ui/lib/iconSizes';
import { useChatbot } from '../../contexts/ChatbotContext';
import { useLocation } from 'react-router-dom';

const HIDDEN_ROUTES = ['/login', '/onboarding'];

export function ChatFAB() {
  const { isOpen, openChat } = useChatbot();
  const location = useLocation();

  // Hide on login/onboarding pages and when drawer is already open
  if (isOpen || HIDDEN_ROUTES.some((r) => location.pathname.startsWith(r))) {
    return null;
  }

  return (
    <button
      onClick={() => openChat()}
      className="fixed bottom-6 right-6 z-50
                 w-12 h-12 rounded-full
                 bg-aqua text-white shadow-lg
                 hover:bg-teal-dark hover:shadow-xl
                 transition-all duration-200
                 flex items-center justify-center"
      title="NexoNurse Assistant"
      aria-label="Open NexoNurse Assistant"
    >
      <StethoscopeAI size={ICON_PX.xl} />
    </button>
  );
}
